import React, { useState, useEffect } from 'react';
import api from '../../../config/axios';
import Paginacao from '../../../components/utils/paginacao';
import AnamneseModal from './Anamnese';
import { FaPlus, FaTimes, FaEye } from 'react-icons/fa';

const AnamneseListaModal = ({ pessoa, onClose }) => {
	const [anamneses, setAnamneses] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState(null);
	
	const [currentPage, setCurrentPage] = useState(1);
	const [totalPages, setTotalPages] = useState(1);
	const [totalRegistros, setTotalRegistros] = useState(0);
	const limit = 10;

	const [selectedAnamnese, setSelectedAnamnese] = useState(null);
	const [isAnamneseModalOpen, setIsAnamneseModalOpen] = useState(false);

	useEffect(() => {
		if (pessoa?.e_cliente) {
			fetchAnamneses(currentPage);
		}
	}, [pessoa, currentPage]);

	const fetchAnamneses = async (page) => {
		setIsLoading(true);
		setError(null);

		try {
			const response = await api.get(`/anamnese-cliente-formularios`, {
				params: {
					id_pessoa_cliente: pessoa.id,
					id_formulario: 1,
					page: page,
					limit: limit
				}
			});

			setAnamneses(response.data.records || []);
			setTotalPages(Math.ceil(response.data.totalRegistros / limit) || 1);
			setTotalRegistros(response.data.totalRegistros || 0);
		} catch (err) {
			setError('Erro ao carregar anamneses. Tente novamente mais tarde.');
		} finally {
			setIsLoading(false);
		}
	};

	const handlePageChange = (page) => {
		setCurrentPage(page);
	};

	const handleAddAnamnese = () => {
		setSelectedAnamnese(null);
		setIsAnamneseModalOpen(true);
	};

	const handleViewAnamnese = (anamnese) => {
		setSelectedAnamnese(anamnese);
		setIsAnamneseModalOpen(true);
	};

	const formatarDataHora = (dataHora) => {
		if (!dataHora) return '-';
		const data = new Date(dataHora);
		return data.toLocaleString('pt-BR', {
			day: '2-digit',
			month: '2-digit',
			year: 'numeric',
			hour: '2-digit',
			minute: '2-digit',
			second: '2-digit'
		}).replace(',', '');
	};

	const handleAnamneseUpdated = () => {
		fetchAnamneses(currentPage);
		setIsAnamneseModalOpen(false);
		setSelectedAnamnese(null);
	};

	return (
		<>
			<div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
				<div className="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
					<div className="modal-content" onClick={(e) => e.stopPropagation()}>
						<div className="modal-header">
							<h4 className="fw-bold mt-2">
								Anamneses - {pessoa?.nome}
							</h4>
							<button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
						</div>

						<div className="modal-body">
							{!pessoa?.e_cliente ? (
								<div className="alert alert-warning" role="alert">
									<strong>Atenção:</strong> Esta pessoa não é um cliente. A anamnese só pode ser preenchida para clientes.
								</div>
							) : (
								<>
									<div className="row mt-2 mb-3">
										<div className="col-md-6 col-12">
											<button className="btn btn-outline-primary" onClick={handleAddAnamnese}>
												<FaPlus /> Adicionar Nova Anamnese
											</button>
										</div>
									</div>

									{error ? (
										<div className="alert alert-danger" role="alert">
											{error}
										</div>
									) : isLoading ? (
										<div className="text-center">
											<div className="spinner-border text-primary" role="status">
												<span className="visually-hidden">Carregando...</span>
											</div>
										</div>
									) : anamneses.length === 0 ? (
										<div className="text-center my-5">
											<p>Nenhuma anamnese encontrada para este cliente.</p>
										</div>
									) : (
										<>
											<div className="table-responsive">
												<table className="table table-striped">
													<thead className="table-custom-primary">
														<tr>
															<th>Data de Criação</th>
															<th>Criado Por</th>
															<th>Última Alteração</th>
															<th>Alterado Por</th>
															<th className="text-center">Ações</th>
														</tr>
													</thead>
													<tbody>
														{anamneses.map((anamnese) => (
															<tr key={anamnese.id}>
																<td className="text-nowrap">{formatarDataHora(anamnese.criado_em)}</td>
																<td className="text-nowrap">{anamnese.criado_por || '-'}</td>
																<td className="text-nowrap">{formatarDataHora(anamnese.alterado_em)}</td>
																<td className="text-nowrap">{anamnese.alterado_por || '-'}</td>
																<td className="text-center text-nowrap">
																	<button
																		className="btn btn-custom-secondary btn-sm"
																		onClick={() => handleViewAnamnese(anamnese)}
																		title="Visualizar/Editar anamnese"
																	>
																		<FaEye />
																	</button>
																</td>
															</tr>
														))}
													</tbody>
												</table>
											</div>

											<div className="d-flex justify-content-between align-items-center mt-4">
												<div className="mb-3">
													<span>
														Total de registros: <strong>{totalRegistros}</strong>
													</span>
												</div>
												<Paginacao
													currentPage={currentPage}
													totalPages={totalPages}
													onPageChange={handlePageChange}
												/>
											</div>
										</>
									)}
								</>
							)}
						</div>

						<div className="modal-footer mt-4">
							<div className="row">
								<div className="col-12 text-end">
									<button className="btn btn-outline-danger" type="button" onClick={onClose}>
										<FaTimes /> Fechar
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			{isAnamneseModalOpen && (
				<AnamneseModal
					pessoa={pessoa}
					anamnese={selectedAnamnese}
					onClose={() => setIsAnamneseModalOpen(false)}
					onAnamneseUpdated={handleAnamneseUpdated}
				/>
			)}
		</>
	);
};

export default AnamneseListaModal; 